<template>
  <div>
    <el-main>

      <div>
        <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline"  style="float: left;text-align: left;padding-top:10px ;">
          <el-form-item label="日期范围筛选：" prop="type">
            <el-button-group>
              <el-button type="primary"  :plain ="btn!=='week'" @click="getListbyBtn('week',siteId)">本周</el-button>
              <el-button type="primary"  :plain ="btn!=='month'"  @click="getListbyBtn('month',siteId)">本月</el-button>
              <el-button type="primary"  :plain ="btn!=='quarter'"  @click="getListbyBtn('quarter',siteId)">本季度</el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="formInline.time"
              type="daterange"
              @change="getList"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"

              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

    </el-main>
    <el-main>
        <el-row :gutter="10">
          <el-col :span="12">
              <div style="height: 600px;" id="questionTotal"> </div>
          </el-col>
          <el-col :span="12">
            <div style="height:  600px;" id="orunknowTotal"> </div>
          </el-col>
        </el-row>
    </el-main>
  </div>
</template>

<script>

import { get } from '@/api/common'
export default {
  name: 'personsend',
  data () {
    return {
      siteId: '',
      formInline: {
        time: ''
      },
      btn: 'week',
      url: '/tabCount/getList'
    }
  },
  created () {
    this.tableHeight = window.innerHeight - 352 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 352 + 'px'
      })()
    }
  },
  mounted () {
    this.siteId = ''
    this.getListbyBtn('week', null)
    this.initmoreLine()
  },
  methods: {
    getList (data) {
      if (this.formInline.time === null) {
        this.getListbyBtn('week', null)
        return
      }
      // console.info(this.formInline.time)
      // console.info(this.formInline.time[1] - this.formInline.time[0])
      let days = parseInt((this.formInline.time[1] - this.formInline.time[0]) / 1000 / 60 / 60 / 24)
      // console.info(days)
      if (days >= 31) {
        this.formInline.time = ''
        this.$notify({
          title: '提示',
          message: '选择日期间隔不得超过30天，请重新选择',
          type: 'warning'
        })
        return
      }
      let params = {
        begintime: this.formInline.time[0],
        endtime: this.formInline.time[1],
        siteId: this.siteId
      }
      get(this.url, params).then(response => {
        if (response.data.code === 0 && response.data.data !== null) {
          let x = response.data.data.qaXs
          let y = response.data.data.CreateQuestTotals
          let series = response.data.data.series
          let legend = response.data.data.legend
          let dataZoom = response.data.data.dataZoom
          let name = response.data.data.name
          this.initLine(x, y, name, dataZoom)
          this.initmoreLine(x, y, name, series, legend, dataZoom)
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '网络异常',
          type: 'warning'
        })
      })
    },
    getListbyBtn (value, siteId) {
      this.formInline.time = null
      this.btn = value
      this.siteId = siteId
      let params = {
        type: value,
        siteId: siteId
      }
      get(this.url, params).then(response => {
        if (response.data.code === 0 && response.data.data !== null) {
          let x = response.data.data.qaXs
          let y = response.data.data.CreateQuestTotals
          let series = response.data.data.series
          let legend = response.data.data.legend
          let dataZoom = response.data.data.dataZoom
          let name = response.data.data.name
          this.initLine(x, y, name, dataZoom)
          this.initmoreLine(x, y, name, series, legend, dataZoom)
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '网络异常',
          type: 'warning'
        })
      })
    },
    initLine (x, y, name, dataZoom) {
      let myChart = this.$echarts.init(document.getElementById('questionTotal'))
      myChart.resize()
      myChart.clear()
      myChart.setOption({
        title: {
          text: '问题创建数量统计'
        },
        xAxis: {
          name: name,
          type: 'category',
          data: x
        },
        tooltip: {
          trigger: 'item'
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: {
          start: dataZoom,
          type: 'inside'
        },
        series: [{
          data: y,
          type: 'line'
        }]
      })
    },
    initmoreLine (x, y, name, series, legend, dataZoom) {
      let myChart = this.$echarts.init(document.getElementById('orunknowTotal'))
      myChart.resize()
      myChart.clear()
      myChart.setOption({
        title: {
          text: '问题提问数量统计'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          legend
        },
        xAxis: {
          name: name,
          type: 'category',
          boundaryGap: true,
          data: x
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: {
          start: dataZoom,
          type: 'inside'
        },
        series: series
      })
    }
  }
}
</script>
<style scoped>
  .activecolor{
    background-color: #67c23a !important;
    color: #fff;
    width: 67px;
    text-align: center;
  }
  .grey{
    background-color: gainsboro;
    width: 67px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/services/questiontotal.vue